/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Components_Mediaslider_Image1Inputs */

const id_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gambar ${i?.index}`)
};

const ms_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imej ${i?.index}`)
};

const da_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Billede ${i?.index}`)
};

const de_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bild ${i?.index}`)
};

const en_us2_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.index}`)
};

const es_es2_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imagen ${i?.index}`)
};

const es_mx2_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imagen ${i?.index}`)
};

const fil_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Larawan ${i?.index}`)
};

const fr_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.index}`)
};

const it_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Immagine ${i?.index}`)
};

const hu_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kép ${i?.index}`)
};

const nl_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Afbeelding ${i?.index}`)
};

const no_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bilde ${i?.index}`)
};

const pl_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obraz ${i?.index}`)
};

const pt_br2_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.index}`)
};

const pt_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imagem ${i?.index}`)
};

const ro_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imagine ${i?.index}`)
};

const fi_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kuva ${i?.index}`)
};

const sv_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bild ${i?.index}`)
};

const vi_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hình ảnh ${i?.index}`)
};

const tr_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Görsel ${i?.index}`)
};

const cs_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obrázek ${i?.index}`)
};

const bg_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изображение ${i?.index}`)
};

const ru_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изображение ${i?.index}`)
};

const uk_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Зображення ${i?.index}`)
};

const ar_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`صورة ${i?.index}`)
};

const hi_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`चित्र ${i?.index}`)
};

const th_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รูป ${i?.index}`)
};

const ja_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`画像 ${i?.index}`)
};

const zh_cn2_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.index}`)
};

const zh_hant1_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.index}`)
};

const ko_components_mediaslider_image1 = /** @type {(inputs: Components_Mediaslider_Image1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Image {index}" |
*
* @param {Components_Mediaslider_Image1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mediaslider_image1 = /** @type {((inputs: Components_Mediaslider_Image1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mediaslider_Image1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mediaslider_image1(inputs)
	if (locale === "ms") return ms_components_mediaslider_image1(inputs)
	if (locale === "da") return da_components_mediaslider_image1(inputs)
	if (locale === "de") return de_components_mediaslider_image1(inputs)
	if (locale === "en-US") return en_us2_components_mediaslider_image1(inputs)
	if (locale === "es-ES") return es_es2_components_mediaslider_image1(inputs)
	if (locale === "es-MX") return es_mx2_components_mediaslider_image1(inputs)
	if (locale === "fil") return fil_components_mediaslider_image1(inputs)
	if (locale === "fr") return fr_components_mediaslider_image1(inputs)
	if (locale === "it") return it_components_mediaslider_image1(inputs)
	if (locale === "hu") return hu_components_mediaslider_image1(inputs)
	if (locale === "nl") return nl_components_mediaslider_image1(inputs)
	if (locale === "no") return no_components_mediaslider_image1(inputs)
	if (locale === "pl") return pl_components_mediaslider_image1(inputs)
	if (locale === "pt-BR") return pt_br2_components_mediaslider_image1(inputs)
	if (locale === "pt") return pt_components_mediaslider_image1(inputs)
	if (locale === "ro") return ro_components_mediaslider_image1(inputs)
	if (locale === "fi") return fi_components_mediaslider_image1(inputs)
	if (locale === "sv") return sv_components_mediaslider_image1(inputs)
	if (locale === "vi") return vi_components_mediaslider_image1(inputs)
	if (locale === "tr") return tr_components_mediaslider_image1(inputs)
	if (locale === "cs") return cs_components_mediaslider_image1(inputs)
	if (locale === "bg") return bg_components_mediaslider_image1(inputs)
	if (locale === "ru") return ru_components_mediaslider_image1(inputs)
	if (locale === "uk") return uk_components_mediaslider_image1(inputs)
	if (locale === "ar") return ar_components_mediaslider_image1(inputs)
	if (locale === "hi") return hi_components_mediaslider_image1(inputs)
	if (locale === "th") return th_components_mediaslider_image1(inputs)
	if (locale === "ja") return ja_components_mediaslider_image1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mediaslider_image1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mediaslider_image1(inputs)
	return ko_components_mediaslider_image1(inputs)
});
export { components_mediaslider_image1 as "components.mediaSlider.image" }